import { render, staticRenderFns } from "./ContactUsSection.vue?vue&type=template&id=5b2062b6&scoped=true"
import script from "./ContactUsSection.vue?vue&type=script&lang=js"
export * from "./ContactUsSection.vue?vue&type=script&lang=js"
import style0 from "./ContactUsSection.vue?vue&type=style&index=0&id=5b2062b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2062b6",
  null
  
)

export default component.exports